{
  "nl": {
    "aiCategories": {
      "categories": {
        "all": "Alle",
        "character": "Persona's",
        "communication": "Beheer",
        "content": "Differentiëren",
        "featured": "Nieuw",
        "feedback": "Beoordelen",
        "inspiration": "Inspireren",
        "material": "Materialen",
        "model": "Taalmodel",
        "null": "Niet gecategoriseerd",
        "planning": "Planning",
        "plugin": "Plugin",
        "pupils": "Leerlingen",
        "teachers": "Docenten",
        "document_qa": "Document-Assistent",
        "undefined": "Niet gecategoriseerd"
      },
      "personaCategories": {
        "famousMen": "Beroemde mannen",
        "famousWomen": "Beroemde vrouwen",
        "funny": "Grappige fictieve figuren"
      },
      "subcategories": {
        "pupils": {
          "exercises": "Oefeningen en leerhelpers",
          "inspiration": "Inspiratie en creativiteit",
          "roleplay": "Chatbots voor rollenspellen"
        },
        "teachers": {
          "feedback": "Feedback en beoordeling",
          "information": "Informatie en oriëntatie",
          "inspiration": "Inspiratie en creativiteit",
          "material": "Materiaal en taken",
          "administration": "Schoolbeheer en organisatie",
          "planning": "Lesplanning en organisatie"
        }
      }
    }
  }
}
